<template>
  <template v-if="field.component === 'TextInput'" >
    <TextInput v-if="count" v-model="store.form[field.id][count - 1]" :type="field.type" :id="field.id" :name="field.id" :placeholder="field.placeholder" style="margin-bottom: 0.5em; width: 100%;" />
    <TextInput v-else v-model="store.form[field.id]" :type="field.type" :id="field.id" :name="field.id" :placeholder="field.placeholder" style="margin-bottom: 0.5em; width: 100%;"/>
  </template>
  <template v-else-if="field.component === 'Switch'">
    <Checkbox v-model="store.form[field.id]" :id="field.id" :name="field.id" :label="field.label" />
  </template>
</template>

<script setup>
import {useStateStore} from "@/stores/store.js";
import TextInput from "@/components/TextInput.vue";
import Checkbox from "@/components/Checkbox.vue";

const props = defineProps(['field', 'count'])
const store = useStateStore()
</script>

<style scoped>

</style>